var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "19.4 6.5 25 6.5 31.1 12.8 31.1 34.1 9.2 34.1 9.2 6.5 14.6 6.5 19.4 6.5",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25 6.5 25 12.9 31.1 12.8",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.3,
    y1: 19,
    x2: 27.7,
    y2: 19,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.3,
    y1: 26,
    x2: 27.7,
    y2: 26,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.8 17.9 14.3 19.3 17.3 16.4",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 26,
    r: 1.5,
    style: {
      fill: "#0194d3"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingIcon);
export default __webpack_public_path__ + "static/media/reporting-icon.d0943beadf2d96e7be6d1691f0d9aa17.svg";
export { ForwardRef as ReactComponent };